/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Who_ProInputs */



/**
* | output |
* | --- |
* | "For production, captioning, and broadcast teams" |
*
* @param {Signup_Compare_Who_ProInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_who_pro = /** @type {((inputs?: Signup_Compare_Who_ProInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Who_ProInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "de") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "it") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "ru") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "es") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "ja") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "hi") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
	return /** @type {LocalizedString} */ ("For production, captioning, and broadcast teams")
});